<app-shipping-type-form />

@if(checkoutService.shippingType() === 'DELIVERY'){
<app-delivery-address-form
  #deliveryAddressFormComponent
  (onChange)="onSelectDeliveryAddress($event)"
/>
} @else if(checkoutService.shippingType() === 'PICKUP'){
<app-pickup-store-form
  #pickupStoreFormComponent
  (onChange)="onSelectPickupStore($event)"
  [hasShippingGroups]="hasShippingGroups()"
/>
}

<app-shipping-product-list
  #shippingProductListcomponent
  [shippingType]="checkoutService.shippingType()"
  [addressShipping]="addressShipping()"
  (onShippingGroupsChange)="onShippingGroupsChange($event)"
/>

@if(hasShippingGroups()){
<app-recipient-type-form (onChange)="onRecipientTypeChange($event)" />

@if(recipientType() === 'ANOTHER'){
<app-recipient-another-form
  #recipientAnotherFormComponent
  [recipient]="recipientAnother"
/>
} }
